import { render } from "./DriversLicenseModal.vue?vue&type=template&id=6aa6c8d2"
import script from "./DriversLicenseModal.vue?vue&type=script&lang=js"
export * from "./DriversLicenseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__